import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useStyle from './MenuItemStyle';

export const ViewMore = ({ showAll }) => {
    const { viewMore: viewMoreClass } = useStyle();
    const { t } = useTranslation();
    return (
        <div onClick={showAll} data-test-id='view-more-btn' className={viewMoreClass}>
            {t('VIEW_MORE', 'View More')}
        </div>);
};

ViewMore.propTypes = {
    isVisible: PropTypes.bool,
    showAll: PropTypes.func,
};
